/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    { if: { hover: true }, tokens: { borderWidth: 2 } },
    { if: { pressed: true }, tokens: { backgroundColor: '#efefef' } },
    {
      if: { focus: true },
      tokens: {
        outerBorderColor: '#000000',
        outerBorderGap: 2,
        outerBorderWidth: 2
      }
    }
  ],
  tokens: {
    backgroundColor: '#ffffff',
    borderColor: '#c9c8c8',
    borderRadius: 8,
    borderWidth: 1,
    contentAlignItems: 'stretch',
    contentFlexGrow: 0,
    contentFlexShrink: 0,
    contentJustifyContent: 'flex-start',
    flex: 1,
    minWidth: 0,
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 0,
    outerBorderWidth: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    shadow: {
      blur: 0,
      color: 'rgba(0, 0, 0, 0)',
      inset: false,
      offsetX: 0,
      offsetY: 0,
      spread: 0
    }
  }
}
export default theme
